import React, { useState } from "react";

import { useEmailAddressResponse } from "screens/question/hooks";
import { Container, Label, StyledTextInput } from "./styled";

export const EmailAddressQuestion = ({ question }) => {
  const {
    RTL,
    value,
    hasError,
    placeholder,
    onChange,
    validateEmail,
  } = useEmailAddressResponse(question);
  const [focus, setFocus] = useState(false);
  return (
    <Container>
      <StyledTextInput
        value={value}
        onChangeText={onChange}
        onBlur={() => {
          validateEmail(value);
          setFocus(false);
        }}
        $hasError={hasError}
        onFocus={() => setFocus(true)}
        keyboardType="email-address"
        $isFocused={focus || value}
      />
      <Label $RTL={RTL} $isFocused={focus || value}>
        {placeholder}
      </Label>
    </Container>
  );
};
